export var DEFAULT_VIDEO_ID = 'fs4eliwya';
export var IFRAME_DEFAULT_TITLE = 'VideoAsk';
export var IFRAME_AVAILABLE_FEATURES = ['camera', 'microphone', 'autoplay', 'encrypted-media', 'fullscreen', 'display-capture'];